@if(data) {
  <div class="card-border p-0.46875 flex flex-col items-start gap-0.625">
    <span data-qa="bm-analytics-card-title" class="font-3 bold500 black-11">{{ data.title }}</span>
    <span data-qa="bm-analytics-card-budget-val" class="font-2 bold600 black-11">{{ data.budgetValue }}</span>
  </div>
}
